import { colors } from '@fikasio/styles';
import React from 'react';
import TrashIcon from 'components/UI/TrashIcon';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import { usePatchUserMeMutation } from 'services/login/api';
import { useAuth } from 'services/login/hooks';

const SettingsAdvanced = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const { user } = auth;

  const [patchUserMe] = usePatchUserMeMutation();

  const onSubmit = async values => {
    patchUserMe({
      ...values,
    });
  };

  return (
    <Form
      initialValues={user ?? undefined}
      mutators={{ ...arrayMutators }}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <label className="form-label">
              {t('censoredWords')}
            </label>
            <FieldArray
              name="censoredWords"
            >
              {({ fields }) => (
                <div>
                  <table
                    style={{
                      width: '100%',
                    }}
                  >
                    <tbody>
                    {
                      fields
                        .map((name, index) => (
                          <tr
                            key={name}
                          >
                            <td>
                              <Field
                                className="form-control"
                                component="input"
                                name={name}
                              />
                            </td>
                            <td width={35}>
                              <TrashIcon
                                onClick={() => fields.remove(index)}
                                size="1x"
                                style={{
                                  color: colors.danger,
                                  cursor: 'pointer',
                                  marginLeft: 10,
                                }}
                              />
                            </td>
                          </tr>
                        ))
                    }
                    </tbody>
                  </table>
                  <Button
                    onClick={() => fields.push('')}
                  >
                    {t('add')}
                  </Button>
                </div>
              )}
            </FieldArray>
          </div>
          <Button
            style={{
              float: 'right',
            }}
            type="submit"
            variant="success"
          >
            {t('save')}
          </Button>
        </form>
      )}
    />
  );
};

export default SettingsAdvanced;
